import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, HostListener, OnDestroy, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as Chart from 'chart.js';
import { IssueService } from '../../../../services/issue.service';
import { getQueryParamFromAncestorRoute } from '../../../../utilities/route.utilities';

@Component({
    selector: 'issues-no-payments-chart',
    template: '<canvas id="basechart" #basechart *ngIf="data.length; else noData"></canvas><ng-template #noData><p class="text-center">No data available</p></ng-template>',
    styles: [':host { width: 90%; position: relative; display:block; }']
})
export class IssuesNoPaymentsChart implements OnDestroy, AfterViewInit {

    @ViewChildren('basechart') basechart: any;
    chart: any;
    subscriptions: any[] = [];
    debounceTimeout = 2000;
    debounceId: any;
    consumerId: string;
    data: any[] = [];
    labels: any[] = [];
    pipe: DatePipe = new DatePipe('en_GB');
    clientId: number;
    siteId: number;
    resizeTimer;

    constructor(
        private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router
    ) { }

    ngAfterViewInit(): void {
        this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        });
    }

    onInitialise() {
        this.clientId = this.route.parent.snapshot.params['clientId'];
        if (this.clientId == null || this.clientId == undefined) this.clientId = this.route.parent.parent.snapshot.params['clientId'];
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');

        this.issueService.issuePaygGetNoPayments(this.clientId, this.siteId).then((result) => {

            if (result.consumersWithPaymentsLast30Days > 0 || result.consumersWithPaymentsLast13Months > 0 ||
                result.consumersWithPaymentsOver3Months > 0 || result.consumersWithNoPayments > 0) {
                this.data = [];
                this.labels = [];
                if (result.consumersWithPaymentsLast30Days > 0) {
                    this.data.push(result.consumersWithPaymentsLast30Days);
                    this.labels.push('Within 30 days');
                }

                if(result.consumersWithPaymentsLast13Months > 0) {
                    this.data.push(result.consumersWithPaymentsLast13Months);
                    this.labels.push('1-3 months');
                }

                if (result.consumersWithPaymentsOver3Months > 0) {
                    this.data.push(result.consumersWithPaymentsOver3Months);
                    this.labels.push('Over 3 months');
                }

                if (result.consumersWithNoPayments > 0) {
                    this.data.push(result.consumersWithNoPayments);
                    this.labels.push('No payment');
                }

                this.createChart();
            }
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
        if (this.debounceId) {
            clearTimeout(this.debounceId);
        }
    }

    private getChartConfig(): any {
        let config = {
            type: 'doughnut',
            options: {
                rotation: 1 * Math.PI,
                circumference: 1 * Math.PI,
                tooltips: {
                    mode: 'index',
                    enabled: true,
                    backgroundColor: '#ffffff',
                    titleFontColor: '#153954',
                    bodyFontColor: '#153954',
                    borderWidth: 2,
                    borderColor: '#009aa3'
                },
                maintainAspectRatio: true,
                legend: {
                    display: true
                },
                scales: {
                    xAxes: [{
                        display: false,
                    }],
                    yAxes: [{
                        display: false,
                    }]
                }
            }
        }

        return config;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
            this.createChart();
        }, 250);
    }

    createChart() {
        if (this.chart != null) this.chart.destroy();
        if (!this.basechart) return;

        let datasets = [] as any;

        datasets.push({
            label: 'PAYG',
            data: this.data,
            backgroundColor: ['#93c01f', '#F9E533', '#FFC000', '#c82b2b'],
            borderColor: ['#93c01f', '#F9E533', '#FFC000', '#c82b2b'],
            pointBorderColor: ['#93c01f', '#F9E533', '#FFC000', '#c82b2b'],
            pointBackgroundColor: ['#93c01f', '#F9E533', '#FFC000', '#c82b2b'],
            pointHoverBackgroundColor: ['#93c01f', '#F9E533', '#FFC000', '#c82b2b'],
            pointHoverBorderColor: ['#93c01f', '#F9E533', '#FFC000', '#c82b2b']
        });

        let config = this.getChartConfig();
        let chartConfiguration: Chart.ChartConfiguration = {
            type: config.type,
            options: config.options,
            data: {
                datasets: datasets,
                labels: this.labels

            },
        };

        if (this.debounceId) {
            window.clearTimeout(this.debounceId);
        };

        this.debounceId = window.setTimeout(() => {
            if (this.chart != null) this.chart.destroy();
            let ctx = this.basechart.first.nativeElement;
            this.chart = new Chart(ctx, chartConfiguration);
        }, this.debounceTimeout);
    }
}
